<script>
    import {list_notebooks} from '../controller.js'
    import Nav from '../components/Nav.svelte'
    import Notebook from '../components/Notebook.svelte'
</script>

<Nav />

<div id="container">
{#each list_notebooks() as notebook }
    <div class="border">
        <Notebook notebook={ notebook } link_title=true/>
    </div>
{/each}
</div>


<style>
#container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    /*grid-template-row: repeat(2, 1fr);*/
    margin: auto;
    text-align: center;
    max-width: 1200px;
}
.border {
    border: 5px solid green;
    margin: 5px;
    padding: 5px;
}
</style>
